module.exports = __webpack_public_path__ + "img/appDownload.f4abc31a.png";